// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserInfo } from "../service/userService";

// Create AuthContext
const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [userSupplier, setUserSupplier] = useState(null);

  useEffect(() => {
    // Initialize user from localStorage or API
    const loadUser = async () => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
    }
      setIsUserLoading(false); // Finished loading
    };
    loadUser();
          // Initialize user from localStorage or API
    const storedUserSupplier = JSON.parse(localStorage.getItem('userSupplier'));
    if (storedUserSupplier) {
      setUserSupplier(storedUserSupplier);
    }
      
      
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    console.log("in logout ");
    setUser(null);
    localStorage.removeItem('user');
       localStorage.removeItem('token');
  };
  
    const refreshUser = async () => {
   // const updatedUser = await getUserFromApi(); // API call
       localStorage.removeItem('user');
       const updatedUser = await getUserInfo(user.userId);
    setUser(updatedUser);
       localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
  };
    
    
  const loginSupplier = (userSupplierData) => {
    setUserSupplier(userSupplierData);
    localStorage.setItem('userSupplier', JSON.stringify(userSupplierData));
  };

  const logoutSupplier = () => {
    setUserSupplier(null);
    localStorage.removeItem('userSupplier');
       localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, userSupplier, loginSupplier, logoutSupplier, refreshUser , isUserLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
